// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles___wrapper___a8zMW","success-placement":"styles___success-placement___3ve-n","hidden":"styles___hidden___DoUed","success":"styles___success___1KboP"};